export const locales = ['en', 'es', 'pt', 'zh', 'hi', 'de', 'vi', 'fr', 'ru', 'it', 'ja'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'en';

